import { render, staticRenderFns } from "./UsersTabAccounts.vue?vue&type=template&id=481b421a"
import script from "./UsersTabAccounts.vue?vue&type=script&lang=js"
export * from "./UsersTabAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports